exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".tagline--taglineCol--3Zsevicy {\r\n  background-color: #F2F2F2;\r\n  text-align: center;\r\n}\r\n\r\n.tagline--tagline--1NRMRtdd {\r\n  font-weight: 300;\r\n  color: #0072CE;\r\n}\r\n\r\n@media only screen and (min-width: 0px) and (max-width: 767px) {\r\n  .tagline--tagline--1NRMRtdd {\r\n    margin: 26px 0;\r\n  }\r\n}\r\n", "", {"version":3,"sources":["C:/Users/mhaf3/ss/SeekerV2/src/components/start/tagline/tagline.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,mBAAmB;CACpB;;AAED;EACE,iBAAiB;EACjB,eAAe;CAChB;;AAED;EACE;IACE,eAAe;GAChB;CACF","file":"tagline.css","sourcesContent":[".taglineCol {\r\n  background-color: #F2F2F2;\r\n  text-align: center;\r\n}\r\n\r\n.tagline {\r\n  font-weight: 300;\r\n  color: #0072CE;\r\n}\r\n\r\n@media only screen and (min-width: 0px) and (max-width: 767px) {\r\n  .tagline {\r\n    margin: 26px 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"taglineCol": "tagline--taglineCol--3Zsevicy",
	"tagline": "tagline--tagline--1NRMRtdd"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/components/start/tagline/tagline.css
// module id = 425
// module chunks = 0